import { Nullable } from '@types'

import { FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

import TruncateLines from './TruncateLines'

const RadioGroupContainer = styled(Box)<{ width?: string; height?: string }>`
  ${({ width, height }) => `
    max-width: ${width || '249px'};
    max-height: ${height || '260px'};
  `}

  padding-left: 10px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

export interface RadioItem {
  value: string
  label: string
}

export interface RadioListProps {
  value: Nullable<string>
  onChange: (value: string) => void
  items: Array<RadioItem>
  alignLeft?: boolean
  width?: string
  height?: string
  overflow?: string
  paddingBottom?: string
}

const RadioList = ({ width, height, value, items, onChange, alignLeft, overflow, paddingBottom }: RadioListProps) => {
  return (
    <RadioGroupContainer width={width} height={height} overflow={overflow} paddingBottom={paddingBottom}>
      <RadioGroup
        sx={{ width: '100%' }}
        value={value}
        onChange={(_, v) => {
          onChange(v)
        }}
        defaultChecked
      >
        {items.map(i => (
          <FormControlLabel
            disableTypography
            key={i.value}
            value={i.value}
            tabIndex={0}
            control={<Radio disableRipple />}
            label={
              <Typography variant="body2">
                <TruncateLines lines={2}>{i.label}</TruncateLines>
              </Typography>
            }
            labelPlacement={alignLeft ? 'start' : 'end'}
            sx={{
              width: '100%',
              justifyContent: alignLeft ? 'space-between' : '',
              margin: alignLeft ? 0 : undefined,
            }}
          />
        ))}
      </RadioGroup>
    </RadioGroupContainer>
  )
}

export default RadioList
